import {AsyncPipe} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatDialog} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatTooltip} from '@angular/material/tooltip';
import {Asset, ReviewAsset} from '@app/asset';
import {CompareRole} from '@app/review/models';
import {
    RemoveReviewItemDialogComponent,
    Result,
} from '@app/review/remove-review-item-dialog/remove-review-item-dialog.component';
import {ReviewService} from '@app/review/review.service';

import * as Sentry from "@sentry/angular";
import {Observable} from 'rxjs';

@Component({
    selector: 'frog-review-asset-item',
    imports: [MatIconButton, MatIcon, MatProgressSpinner, MatTooltip, AsyncPipe],
    templateUrl: './review-asset-item.component.html',
    styleUrl: './review-asset-item.component.scss',
})
export class ReviewAssetItemComponent {
    @Input() asset: Asset;
    @Input() review: ReviewAsset;
    @Input() index: number;
    // Which compare slot (if any) this Asset is flagged for - see docs/design/review-compare-assets.md
    // §3.1. Drives the A/B badge (replacing the compare-flag button) and the row's A/B coloring.
    @Input() compareRole: CompareRole = null;
    @Output() infoLock: EventEmitter<boolean>;
    @Output() toggleCompare: EventEmitter<void>;

    protected failedAssetIds$: Observable<Set<string>>;

    constructor(
        private reviewService: ReviewService,
        private matDialog: MatDialog,
    ) {
        this.infoLock = new EventEmitter<boolean>();
        this.toggleCompare = new EventEmitter<void>();
        this.failedAssetIds$ = this.reviewService.failedAssetIds$;
    }

    protected compareHandler(event: MouseEvent) {
        event.stopPropagation();
        this.toggleCompare.emit();
    }

    public removeHandler() {
        this.matDialog
            .open(RemoveReviewItemDialogComponent, {
                maxWidth: '600px',
                width: '80vw',
                data: {
                    asset: this.asset,
                    review: this.review,
                },
            })
            .afterClosed()
            .subscribe((result: Result) => {
                switch (result) {
                    case Result.Remove:
                        this.reviewService
                            .removeAsset(this.asset.id, this.review.id, false)
                            .subscribe({error: (err) => Sentry.captureException(err)});
                        break;
                    case Result.Delete:
                        this.reviewService
                            .removeAsset(this.asset.id, this.review.id, true)
                            .subscribe({error: (err) => Sentry.captureException(err)});
                        break;
                }
            });
    }

    protected lockInfo() {
        this.infoLock.emit(true);
    }
}
